import React, { useCallback } from 'react';

import { usePreviewPanelsActions } from '@atlassian/preview-panels-api/use-preview-panel-actions';

import type { BylineContentType } from '../utils/contentAri.ts';

import { PANEL_PRODUCT, PANEL_TYPE } from './previewPanelConstants.ts';
import { TeamworkGraphPreviewPanel } from './TeamworkGraphPreviewPanel.tsx';
import {
	getTeamworkGraphPreviewPanelId,
	useIsTeamworkGraphPreviewPanelOpen,
} from './teamworkGraphPreviewPanelState.ts';

export const useTeamworkGraphPreviewPanel = (
	contentId?: string,
	contentType?: BylineContentType,
): {
	isTeamworkGraphPreviewPanelOpen: boolean;
	openTeamworkGraphPreviewPanel: () => void;
} => {
	const { open } = usePreviewPanelsActions();
	const panelId = getTeamworkGraphPreviewPanelId(contentId);
	// Asked for by id, not bare: `useIsPreviewPanelOpen()` reports any open preview panel,
	// so a page preview panel would read as this one.
	const isTeamworkGraphPreviewPanelOpen = useIsTeamworkGraphPreviewPanelOpen(contentId);

	const openTeamworkGraphPreviewPanel = useCallback(() => {
		open({
			panel: {
				id: panelId,
				type: PANEL_TYPE,
				product: PANEL_PRODUCT,
				content: () => (
					<TeamworkGraphPreviewPanel contentId={contentId} contentType={contentType} />
				),
			},
		});
	}, [open, panelId, contentId, contentType]);

	return {
		isTeamworkGraphPreviewPanelOpen,
		openTeamworkGraphPreviewPanel,
	};
};
